module.exports = __webpack_public_path__ + "media/images/redesign-images/promotions/promos-05-3eb03be3f0ae50cf311f9b5db87a5892.jpg";